var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",class:{'mod-mobile': _vm.mobile}},[_vm._v(" All Right Reserved © 3NSoft, Inc 2021 - 2024 ")])}
var staticRenderFns = []

export { render, staticRenderFns }